// ----------------------------------------------------------------------
export const Timeline = ({ theme }) => {
    return {
        MuiTimelineConnector: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.divider
                }
            }
        }
    };
};
//# sourceMappingURL=Timeline.js.map